import { ACCESS } from '../../constants/authz';

/** Nav item keys → authz requirement */
export const MENU_ACCESS = Object.freeze({
  dashboard: ACCESS.PUBLIC_AUTHENTICATED,
  campaignPlanning: ACCESS.SUPER_ADMIN_ONLY,
  campaignExecution: ACCESS.SUPER_ADMIN_ONLY,
  leads: ACCESS.SUPER_ADMIN_ONLY,
  reporting: ACCESS.REPORTING_VIEW,
  analytics: ACCESS.REPORTING_VIEW,
  management: ACCESS.SUPER_ADMIN_ONLY,
  organization: ACCESS.SUPER_ADMIN_ONLY,
  users: ACCESS.SUPER_ADMIN_ONLY,
  intervene: ACCESS.INTERVENE_VIEW,
  webForm: ACCESS.SUPER_ADMIN_ONLY,
  templates: ACCESS.WHATSAPP_TEMPLATES_VIEW,
  templateQueue: ACCESS.SUPER_ADMIN_ONLY,
  wabaAppList: ACCESS.WHATSAPP_WABA,
  waSettings: ACCESS.WHATSAPP_WABA,
  flowBuilder: ACCESS.FLOW_VIEW,
  sms: ACCESS.SMS_TEMPLATES_VIEW,
  smsTemplates: ACCESS.SMS_TEMPLATES_VIEW,
  smsLog: ACCESS.SMS_LOGS_VIEW,
  ecommerce: ACCESS.SUPER_ADMIN_ONLY,
  ai: ACCESS.AI_DASHBOARD_VIEW,
  vectorDatabase: ACCESS.VECTOR_DATABASE_VIEW,
  entity: ACCESS.DATASETS_VIEW,
  tools: ACCESS.TOOLS_VIEW,
  machadaloStudio: ACCESS.SUPER_ADMIN_ONLY,
  conceptBuilder: ACCESS.EDTECH_CONCEPT_BUILDER,
  practiceTest: ACCESS.EDTECH_PRACTICE_TEST,
  knowledgeMap: ACCESS.EDTECH_KNOWLEDGE_MAP,
  syllabusBuilder: ACCESS.EDTECH_SYLLABUS_BUILDER,
  performanceMap: ACCESS.EDTECH_PERFORMANCE_MAP,
  parentDashboard: ACCESS.EDTECH_PARENT_DASHBOARD,
  teacherDashboard: ACCESS.EDTECH_TEACHER_DASHBOARD,
  academicDashboard: ACCESS.EDTECH_ACADEMIC_INFO,
  questionbank: ACCESS.EDTECH_QUESTION_BANK,
  profileManagement: ACCESS.PROFILE_MANAGEMENT_VIEW,
  profileList: ACCESS.SUPER_ADMIN_ONLY,
  licenseManagement: ACCESS.SUPER_ADMIN_ONLY,
  userCreate: ACCESS.USER_CREATE,
  userList: ACCESS.USER_MANAGEMENT_VIEW,
  supplier: ACCESS.SUPER_ADMIN_ONLY,
  inventory: ACCESS.SUPER_ADMIN_ONLY,
  bookingEngine: ACCESS.SUPER_ADMIN_ONLY,
});

/**
 * @param {import('../../config/navigation/navigation.constants.js').NavItem|import('../../config/navigation/navigation.constants.js').NavLeaf} item
 * @param {import('../../authorization/types/authz.types').AuthzRequirement} [parentAccess]
 */
export function resolveItemAccess(item, parentAccess = null) {
  if (item?.access != null || item?.access === null) {
    return item.access;
  }
  if (item?.accessKey && Object.prototype.hasOwnProperty.call(MENU_ACCESS, item.accessKey)) {
    return MENU_ACCESS[item.accessKey];
  }
  if (item?.key && Object.prototype.hasOwnProperty.call(MENU_ACCESS, item.key)) {
    return MENU_ACCESS[item.key];
  }
  if (parentAccess != null) {
    return parentAccess;
  }
  return ACCESS.SUPER_ADMIN_ONLY;
}

export { ACCESS };
